export const processStringValue = (string: string): string | undefined => {
  if (typeof string !== 'string') return string;

  return string?.length ? string : undefined;
};
